import type { EChartsOption } from 'echarts';

export const animationDefaults: Pick<
  EChartsOption,
  | 'animation'
  | 'animationDuration'
  | 'animationDurationUpdate'
  | 'animationEasing'
  | 'animationEasingUpdate'
  | 'animationDelay'
  | 'animationDelayUpdate'
  | 'animationThreshold'
> = {
  animation: true,
  animationDuration: 700,
  animationDurationUpdate: 500,
  animationEasing: 'cubicOut',
  animationEasingUpdate: 'cubicInOut',
  animationDelay: (idx: number) => idx * 35,
  animationDelayUpdate: (idx: number) => idx * 20,
  animationThreshold: 4000,
};
